// Cuándo llegó un aviso de la campana. El relativo ("Hace 3h") solo sirve para lo reciente: pasado
// un día, "Hace 5 días" ya no dice la fecha ni la hora, que es lo que el usuario necesita.
type T = (k: string, o?: Record<string, unknown>) => string;

export interface NotificationTimeOptions {
  /** Reloj de referencia; por omisión, ahora. */
  now?: Date;
  /** Zona IANA; por omisión, la del navegador. */
  timeZone?: string;
}

const HOUR_MS = 3_600_000;
const DAY_MS = 24 * HOUR_MS;

export function formatNotificationTime(iso: string, locale: string, t: T, opts: NotificationTimeOptions = {}): string {
  const ts = new Date(iso).getTime();
  if (Number.isNaN(ts)) return iso;
  const now = opts.now ?? new Date();
  const diff = now.getTime() - ts;
  if (diff < HOUR_MS) return t('time.moment');
  if (diff < DAY_MS) return t('time.hours', { n: Math.floor(diff / HOUR_MS) });
  // El año se compara en la zona del usuario: el 31-dic a las 20:00 en CDMX ya es 1-ene en UTC.
  const yearOf = (d: number) => new Intl.DateTimeFormat('en', { year: 'numeric', timeZone: opts.timeZone }).format(d);
  return new Intl.DateTimeFormat(locale, {
    day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit', hour12: false, timeZone: opts.timeZone,
    year: yearOf(ts) === yearOf(now.getTime()) ? undefined : 'numeric',
  }).format(ts);
}

/** Fecha y hora completas, para el tooltip: la etiqueta corta no siempre basta. */
export function formatNotificationTimeFull(iso: string, locale: string, timeZone?: string): string {
  const ts = new Date(iso).getTime();
  if (Number.isNaN(ts)) return iso;
  return new Intl.DateTimeFormat(locale, { dateStyle: 'long', timeStyle: 'short', timeZone }).format(ts);
}
